import React from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import flatpickr from "flatpickr";
import confirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate' ;
import {ajaxNewReminder, addEmailKeywordRecipient} from '../redux/FeedbackRedux';
import Alert from '../Alert';
import FormError from "../FormError";

class PotentialRecipientsEmail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {email_error: false};

        this.handleAddEmailRecipient = this.handleAddEmailRecipient.bind(this);
    }

    componentDidMount() {
    }

    handleClick(event) {
    }

    handleAddEmailRecipient(user, event) {
        event.preventDefault();
        var email_map = this.props.state.email_recipients.map((item, key) => item.email);
        if (email_map.includes(user.email)) {
            this.setState({email_error: __('This email address is already in the list.')});
            return;
        } else {
            var info = {
                id: user.id,
                email: user.email,
                name: (user.firstname + " " + user.lastname),
                email_error: this.props.email_error
            };
            this.props.dispatch(addEmailKeywordRecipient(info));
            this.setState({email_error: false});
            jQuery('.modal').modal('hide');
        }
    }

    render() {
        return (
            <div className="potentialRecipientsList">
                <p>
                    {__('Users can receive a notification whenever Feedbacks or chat messages with certain keywords are submitted for this business. The message will include the keywords used, along with a link to view the Feedback. Select a user from the list below.')}
                </p>
                <FormError error_message={this.state.email_error}></FormError>
                <hr/>

                {this.props.state.potential_recipients.map((item, key) => (
                    <div className="d-inline-block mr-2 mb-2" key={item.uuid}>
                        <a
                            href=""
                            className="btn btn-outline-primary btn-sm"
                            onClick={this.handleAddEmailRecipient.bind(
                                this,
                                item
                            )}
                        >
                            <i
                                className="fas fa-user-plus mr-1"
                                aria-hidden="true"
                            ></i>{" "}
                            {(item.firstname + " " + item.lastname).trim()}
                        </a>
                    </div>
                ))}

            </div>
        );

    }
}

function mapStateToProps(state) {
    return {state: state}
}

export default connect(mapStateToProps)(PotentialRecipientsEmail);
